<template>
	<span class="created" v-else>{{ date }}</span>
</template>

<script>
	export default {
		name: 'ColumnCompletedAt',
		props: {
			rowData: {
				type: Object,
				required: true
			},
			rowIndex: {
				type: Number
			}
		},
		computed: {
			date() {
				return this.rowData.completedAt ? this.rowData.completedAt : 'Unknown';
			}
		}
		//Use computed properties instead of data here, otherwise sorting/pagination will break
	}
</script>

<style lang="scss" scoped>
	.created {
		text-transform: uppercase;
	}
</style>
